var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"context-menu-actions",class:{ flipped: _vm.flipped }},_vm._l((_vm.actions),function(action){return _c('li',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
      content: _vm.getDescription(action),
      offset: 12,
      delay: { show: 300, hide: 100 },
      placement: _vm.flipped ? 'right-center' : 'left-center',
    }),expression:"{\n      content: getDescription(action),\n      offset: 12,\n      delay: { show: 300, hide: 100 },\n      placement: flipped ? 'right-center' : 'left-center',\n    }"}],key:action.type,class:[
      'context-menu-action-container',
      {
        'is-selected': action.type === _vm.selectedActionType,
      } ]},[_c('div',{staticClass:"context-menu-action"},[_c('button',{staticClass:"menu-action-button",on:{"click":function($event){return _vm.handleSelect(action.type)}}},[_c('Icon',{attrs:{"icon":action.icon}})],1)])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }